import DomainCommon from './common';

const MissionPriceTypeService = {
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/missionPriceType`,
                resolve, reject
            });
        });
    },
    findById: (groupId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/missionPriceType/${groupId}`,
                resolve, reject
            });
        });
    },
};

export default MissionPriceTypeService;



// WEBPACK FOOTER //
// ./src/service/missionType.js